import { PrivateAPINamespace } from '../PrivateAPINamespace';
import { ApiConfig, Frame } from '../../limitPrivateAPI';
import { ComponentRef } from '@wix/editor-platform-sdk-types';

@ApiConfig(Frame)
export class CustomElementNamespace extends PrivateAPINamespace {
  static readonly namespace = 'customElement';

  getAttributes(compRef: ComponentRef) {
    const unscopedCompRef = this.getUnscopedCompRef(compRef);
    const data = this.ps.ds.components.data.get(unscopedCompRef) ?? {};
    return JSON.parse(data?.initialAttributes ?? '{}');
  }

  getAttribute(compRef: ComponentRef, attributeName: string) {
    const unscopedCompRef = this.getUnscopedCompRef(compRef);
    const attributes = this.getAttributes(unscopedCompRef);
    return attributes[attributeName];
  }

  setAttribute(compRef: ComponentRef, attributeName: string, value: string) {
    const unscopedCompRef = this.getUnscopedCompRef(compRef);
    const attributes = this.getAttributes(unscopedCompRef);

    this.setAttributes(unscopedCompRef, {
      ...attributes,
      [attributeName]: value,
    });
  }

  setAttributes(compRef: ComponentRef, attrs: Record<string, string>) {
    const unscopedCompRef = this.getUnscopedCompRef(compRef);
    // TODO: should reload?
    const data = this.ps.ds.components.data.get(unscopedCompRef) ?? {};

    this.ps.ds.components.data.update(unscopedCompRef, {
      ...data,
      initialAttributes: JSON.stringify(attrs),
    });
  }

  setPreloadFonts(compRef: ComponentRef, fontFamilies: string[]) {
    const style = this.ps.ds.components.style.get(compRef) || {
      type: 'ComponentStyle',
      styleType: 'custom',
      skin: 'wixui.skins.CustomElement',
      componentClassName: 'wixui.CustomElementComponent',
      style: {
        properties: {},
        propertiesSource: {},
      },
    };

    const combinedFontFamilies = joinFontFamilies(fontFamilies);

    this.ps.ds.components.style.update(compRef, {
      ...style,
      style: {
        ...(style.style ?? {}),
        properties: {
          ...(style.style?.properties ?? {}),
          fontFamily: combinedFontFamilies,
        },
        propertiesSource: {
          ...(style.style?.propertiesSource ?? {}),
          fontFamily: 'value',
        },
      },
    });
  }
}

const formatFontFamily = (fontFamily: string): string => {
  if (fontFamily.startsWith(`"`) && fontFamily.endsWith(`"`)) {
    return fontFamily;
  }

  if (fontFamily.includes(' ')) {
    return `"${fontFamily}"`;
  }

  return fontFamily;
};

const joinFontFamilies = (fontFamilies: string[]): string => {
  const uniqueFontFamilies = Array.from(new Set(fontFamilies));
  return uniqueFontFamilies.map(formatFontFamily).join(',');
};
